import React, { createContext, useContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { getMessages, defaultLocale, locales } from '../localization';

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
    const getInitialLocale = () => {
        const saved = localStorage.getItem('goldhub_locale');
        if (saved && saved in locales) return saved;
        return defaultLocale;
    };

    const [locale, setLocale] = useState(getInitialLocale);

    const switchLocale = (newLocale) => {
        setLocale(newLocale);
        localStorage.setItem('goldhub_locale', newLocale);
    };

    const messages = getMessages(locale);

    return (
        <LocaleContext.Provider value={{ locale, switchLocale, locales }}>
            <IntlProvider messages={messages} locale={locale} defaultLocale={defaultLocale}>
                {children}
            </IntlProvider>
        </LocaleContext.Provider>
    );
}

export const useLocale = () => useContext(LocaleContext);
